// https://fluentsite.z22.web.core.windows.net/quick-start
import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  tokens,
} from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { HashRouter as Router, Navigate, Route, Routes, BrowserRouter } from "react-router-dom";
import { app } from "@microsoft/teams-js";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import Privacy from "./Privacy";
import TermsOfUse from "./TermsOfUse";
import Tab from "./Tab";
import TabConfig from "./TabConfig";
import RXComponent from "./RXComponent";
import { TeamsFxContext } from "./Context";
import config from "./sample/lib/config";
import Login from "./sample/login";
import React from "react";
import ClosePopup from "./ClosePopup";
import ConsentPopup from "./ConsentPopup";
import * as microsoftTeams from "@microsoft/teams-js";
import AssignedSpacePage from "./sample/AssignedSpace";
import MySettings from "./sample/my-settings";
import WorkPlacePage from "./sample/work_place";
import WorkSpaceExcption from "./sample/work_place_excep";
import { Default as Loader } from "./loader/loader"
import loaderService from './loader/loader.service';
import TeamWorkPlaces from "./sample/teams_workplaces";
import { useNavigate } from "react-router-dom";
import { CommonInfo } from "../CommonData/Config";
import { useTeamsContext } from "../utils/useTeamsContext";
import { getFluentTheme } from "./themeMapper";
import { AppContext } from "./AppContext";
import { ROUTES } from "../CommonData/RouteConstants";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
const Commondata = CommonInfo;


export default function App() {
  const navigate = useNavigate();
  const { inTeams, themeString } = useTeamsContext();
  const fluentTheme = getFluentTheme(themeString);

  const loggedInItem = localStorage.getItem("loggedIn");

  const { teamsUserCredential } = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint!,
    clientId: config.clientId!,
  });

  useEffect(() => {
    // Update localStorage whenever themeString changes
    localStorage.setItem('Theme', themeString);
  }, [themeString]);

  useEffect(() => {
    if (inTeams === null) return;

    if (loggedInItem && JSON.parse(loggedInItem) === true) {
      const currentUrl = localStorage.getItem("currentUrl");
      if (currentUrl) {
        const cleanedUrl = currentUrl.replace(CommonInfo.folderName, "");
        navigate(cleanedUrl);
      }
    } else {
      navigate("*");
      Commondata.resetValues();
    }
  }, [inTeams]);

  // ✅ Early return AFTER hooks
  if (inTeams === null) {
    return null; // or splash screen
  }

  return (
    <AppContext.Provider
      value={{
        isTeams: inTeams,
        appTheme: themeString,
        fluentTheme,
        teamsUserCredential,
      }}
    >
      <FluentProvider theme={fluentTheme} style={{ minHeight: "100vh" }}>
        <div ref={(ref) => (loaderService.loaderElement = ref)} style={{ display: "none" }}>
          <Loader />
        </div>

        <Routes>
          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path={ROUTES.WORKPLACES} element={<WorkPlacePage />} />
          <Route path={ROUTES.EXCEPTIONS} element={<WorkSpaceExcption />} />
          <Route path={ROUTES.ASSIGNEDSPACE} element={<AssignedSpacePage />} />
          <Route path={ROUTES.MYSETTINGS} element={<MySettings />} />
          <Route path={ROUTES.TEAMSWORKPLACES} element={<TeamWorkPlaces />} />
          <Route path="*" element={<Navigate to={ROUTES.LOGIN} />} />
        </Routes>
      </FluentProvider>
    </AppContext.Provider>
  );
}
